import { domains } from "../Constants";

// Production hosts are only ever served over TLS; plain http is a local
// dev affordance (web client on localhost:3000, selectlocal.com:3000).
const hostsForScheme = (protocol: string): readonly string[] => {
	if (protocol === "https:") return [...domains.production, ...domains.development];
	if (protocol === "http:") return domains.development;
	return [];
};

// The mobile app's expo-linking scheme: "select" in production builds,
// "selectdev" in staging and dev builds, both with the auth-callback path.
const mobileCallbackSchemes: readonly string[] = ["select:", "selectdev:"];
const mobileCallbackHost = "auth-callback";

export function isValidRedirectUrl(url: string): boolean {
	if (!url) return false;
	let parsed: URL;
	try {
		parsed = new URL(url, window.location.origin);
	} catch {
		return false;
	}
	const hosts = hostsForScheme(parsed.protocol);
	if (hosts.length === 0) return false;
	if (parsed.origin === window.location.origin) return true;
	const hostname = parsed.hostname;
	return hosts.some(
		(domain) => hostname === domain || hostname.endsWith(`.${domain}`),
	);
}

export function isValidMobileRedirectUri(url: string): boolean {
	let parsed: URL;
	try {
		parsed = new URL(url);
	} catch {
		return false;
	}
	return (
		mobileCallbackSchemes.includes(parsed.protocol) &&
		parsed.hostname === mobileCallbackHost
	);
}
